import React from "react";
import { useParams, Link } from "react-router-dom";
import { blogPosts } from "./BlogPosts";

const BlogPostPage = () => {
  const { title } = useParams();
  const post = blogPosts.find((p) => p.title === title);

  if (!post) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="bg-white p-8 rounded-lg shadow-md text-center max-w-md">
          <h1 className="text-2xl font-bold mb-2">Post Not Found</h1>
          <p className="text-gray-600 mb-4">
            Sorry, the blog post you are looking for does not exist.
          </p>
          <Link
            to="/blog/"
            className="text-[#fe7590] hover:underline font-medium"
          >
            ← Back to Blog
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-md">
        <Link to="/blog" className="text-[#fe7590] hover:underline font-medium">
          ← Back to Blog
        </Link>
        <h1 className="text-3xl font-bold text-gray-800 mt-4 mb-2">
          {post.title}
        </h1>
        <img src={post.img} />

        <div
          className="prose max-w-none text-gray-700"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      </div>
    </div>
  );
};

export default BlogPostPage;
